import { c as _c } from "react/compiler-runtime";
import { MOBILE_APP_IOS, MOBILE_APP_ANDROID } from "@/constants";
import Image from "next/image";
import Link from "next/link";
export function ShareMobileApp(t0) {
  const $ = _c(11);
  const {
    platform,
    target: t1
  } = t0;
  const target = t1 === undefined ? "_blank" : t1;
  const appUrl = platform === "ios" ? MOBILE_APP_IOS : MOBILE_APP_ANDROID;
  const imageSrc = platform === "ios" ? "/app-store.png" : "/play-store.png";
  const altText = platform === "ios" ? "6529 Mobile iOS" : "6529 Mobile Android";
  let t2;
  if ($[0] !== appUrl || $[1] !== target) {
    t2 = e => {
      if (target === "_self") {
        e.preventDefault();
        if (typeof window !== "undefined" && window.top) {
          window.top.location.href = appUrl;
        }
      }
    };
    $[0] = appUrl;
    $[1] = target;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== altText || $[4] !== imageSrc) {
    t3 = <Image unoptimized={true} priority={true} loading="eager" src={imageSrc} alt={altText} width={200} height={60} placeholder="empty" className="hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-ease-out" />;
    $[3] = altText;
    $[4] = imageSrc;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== appUrl || $[7] !== handleClick || $[8] !== t3 || $[9] !== target) {
    t4 = <Link href={appUrl} target={target} rel="noopener noreferrer" onClick={handleClick} className="decoration-none tw-flex tw-flex-col tw-items-center tw-gap-8">{t3}</Link>;
    $[6] = appUrl;
    $[7] = handleClick;
    $[8] = t3;
    $[9] = target;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}